<template>
  <div class="component meal-choices">
    <h2 class="meal-title">{{ $t('general.label.meals') }}</h2>

    <div class="meal-details" v-for="(mealChoice, index) in cartItem.meals" :key="`meal-${index}`">
      <h3>{{ $tc(`${guestPicker.paxPrefix}guest-picker.${mealChoice.type}`, 1).includes(`${guestPicker.paxPrefix}guest-picker.${mealChoice.type}`) ? 
          guestPicker.paxLabels[mealChoice.type] : $tc(`${guestPicker.paxPrefix}guest-picker.${mealChoice.type}`, 1) 
         }} {{ mealChoice.idx + 1 }}</h3>
      <form-input type="select" :label="$t('form.label.meal')" icon="meal" v-model="mealChoice.meal" :options="cartItem.details.lunches" />
      <form-input type="textarea" :label="$t('form.label.dietary-requirements')" info="Optional" icon="mealcomment" v-model="mealChoice.notes"/>
    </div>

  </div>
</template>

<script>

import FormInput from '@/components/FormInput.vue';

export default {
  props: ['cartItem', 'guestPicker', 'initialMeals'],

  data() {
    return {
      // we only want to use the given prop once, so some hacky control logic here to know when to use it.
      initialMealsData: false
    }
  },

  components: {
    FormInput
  },

  watch: {
    'cartItem.pax'(val) {
      this.setupInitialMeals();
      this.updateChoices(val);
    }
  },

  created() {
    this.setupInitialMeals();
    this.updateChoices(this.cartItem.pax);
  },

  methods: {
    updateChoices(val) {
      // we want to update the meal choice groups when the pax changes.
      // if pax decreases, we don't want to remove form input user may have already entered.
      if (val && this.cartItem.details.lunches.length) {
        let gp = this.guestPicker;
        let mc = this.cartItem.meals.slice(0);
        let defaultLunch = this.cartItem.details.lunches[0].value;
        let keys = gp.modalStateKeys;
        let cur = {};
  
        if (this.initialMealsData && this.initialMealsData.length) {
          mc = this.initialMealsData.map((item, idx) => {
            return {
              type: item.type ? item.type : 'adults',
              idx: item.idx > 0 ? item.idx - 1 : idx,
              meal: item.id,
              notes: item.notes
            };
          });
          this.initialMealsData = undefined;
        } else {
          // generate the current counts for each type so we can compare to val
          mc.forEach(item => {
            if (!cur[item.type]) {
              cur[item.type] = 0;
            }
            cur[item.type]++;
          });

          keys.forEach(key => {
            if (val[key]) {
              if (cur[key] && val[key] < cur[key]) {
                // if we decreased, then filter out the ones at the end
                mc = mc.filter(item => {
                  return item.type !== key || item.idx < val[key];
                });
              } else {
                // otherwise we need to add entries
                let beg = cur[key] || 0; // in case undefined
                for (let i = beg; i < val[key]; i++) {
                  mc.push({
                    type: key,
                    idx: i,
                    meal: defaultLunch,
                    notes: ''
                  });
                }
              }

            } else {
              // remove these choices
              mc = mc.filter(item => {
                return item.type != key;
              });
            }
          });

          mc.sort((a, b) => {
            let cmp = keys.indexOf(a.type) - keys.indexOf(b.type);
            if (cmp === 0) {
              cmp = a.idx - b.idx;
            }
            return cmp;
          });
        }
        this.cartItem.meals = mc;
      }
    },

    setupInitialMeals() {
      if (this.initialMealsData === false && this.initialMeals) {
        this.initialMealsData = this.initialMeals;
      }
    },

  }
}

</script>